/**
 * Il file global mi serve per la posssibilità di cambiare il valore delle variabili d'ambiente dopo la build
 * Se aggiungi una nuova variabile nel file .env, lo aggiungi anche qui sempre come stringa e poi quando lo vuoi usare nel
 * codice basta che chiami window.CONFIG.<nome variabile> che ti verrà anche consigliata
 */

import IStyles from "assets/styles";

const DONT_ALLOW_INSTALL_PROMPT = "hsb-install-prompt-not-allowed";
const LAST_INSTALL_PROMPT_TIMESTAMP = "hsb-install-prompt-timestamp";

export { DONT_ALLOW_INSTALL_PROMPT, LAST_INSTALL_PROMPT_TIMESTAMP };

declare global {
  interface Window {
		CONFIG: {
			REACT_APP_WS_HSB: string;
			REACT_APP_WS_MULTILINGUA: string;
			REACT_APP_ATL_BASE_URL: string;
			REACT_APP_PAYMENT: {
				ENABLED: boolean;
				PAYPAL_PAYMENT_ENABLED: Boolean;
				STRIPE_PAYMENT_ENABLED: Boolean;
				BANK_TRANSFER_PAYMENT_ENABLED: Boolean;
				PAYPAL_CLIENT_ID: string;
				STRIPE_PK: string;
				IBAN: string;
				INTESTATARIO: string;
				BANCA: string;
				CAUSALE: string;
			};
			REACT_APP_GA_TRACKING: string;
			REACT_APP_CONSENSI: {
				SMS: { ENABLED: boolean };
				PRIVACY: { ENABLED: boolean; REQUIRED: boolean };
				COMUNICAZIONI_MMG: { ENABLED: boolean; REQUIRED: boolean };
				COMUNICAZIONI_SERVIZIO: { ENABLED: boolean; REQUIRED: boolean };
				MARKETING: { ENABLED: boolean; REQUIRED: boolean };
				DOC_SANITARI: { ENABLED: boolean; REQUIRED: boolean };
				TERZI: { ENABLED: boolean; REQUIRED: boolean };
			};
			REACT_APP_CONDIZIONI_VENDITA_LINK: string;
			REACT_APP_SITO_VETRINA_LINK: string;
			REACT_APP_NOTIFICHE: boolean;
			FIREBASE: {
				APP_CONFIG: {
					apiKey: string;
					authDomain: string;
					projectId: string;
					storageBucket: string;
					messagingSenderId: string;
					appId: string;
				};
				MESSAGING_KEY: string;
				PUSH_NOTIFY_ENABLED: Boolean;
			};
			CULTURES: string[];
			REACT_APP_CONTATTI: {
				TELEFONO: string;
				MAIL: string;
			};
			REACT_APP_TIPO_SELEZIONE_AREA: number;
			REACT_APP_MOSTRA_FOOTER: boolean;
			REACT_APP_INSTALL_PWA: {
				DISABLE_DEFAULT_PROMPT: boolean;
				REITERATE_INSTALL_PROMPT_INTERVAL: number;
			};
		};
		STYLES: IStyles;
	}	
}
